import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Logo } from "@/components/Logo";

export function SiteHeader({ nav, right = null }) {
  return (
    <header className="site-header-wrap">
      <div className="site-header">
        <div className="site-container h-[100px] flex items-center gap-8">
          <Link to="/" className="brand-link flex items-center" data-testid="header-home-link" aria-label="Military Police home">
            <Logo height={44} />
          </Link>
          <span className="brand-sub" data-testid="operation-badge">Major Investigation Team · Operation SPORE</span>
          {right}
        </div>
      </div>
      {nav}
    </header>
  );
}

export const SiteFooter = () => (
  <footer className="site-footer mt-auto" data-testid="site-footer">
    <div className="site-container py-12 grid grid-cols-3 gap-12">
      <div>
        <Logo height={30} variant="white" />
        <p className="mt-4 text-[16px] text-[#c9cbcc]">Major Investigation Team · Operation SPORE</p>
      </div>
      <p className="text-[16px] text-[#c9cbcc]">A fictional investigation portal for a live immersive performance. Not affiliated with any real police service.</p>
      <p className="text-[16px] text-[#c9cbcc]">Feeling unwell or frightened in the building? Tell a member of crew straight away.</p>
    </div>
  </footer>
);

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="breadcrumbs" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-2">
      {items.map(([label, to], i) => (
        <li key={label} className="flex items-center gap-2">
          {i > 0 && <ChevronRight size={14} className="opacity-60" />}
          {to ? <Link to={to} className="link">{label}</Link> : <span aria-current="page">{label}</span>}
        </li>
      ))}
    </ol>
  </nav>
);

const TAGS = { done: ["Completed", "tag-green"], progress: ["In progress", "tag-blue"], todo: ["Not started", "tag-grey"] };

export const Tag = ({ status, testid }) => {
  const [label, cls] = TAGS[status];
  return <strong className={`tag ${cls}`} data-testid={testid}>{label}</strong>;
};
